import { useState } from 'react';
import Modal from 'react-modal';

const SaveButtonWithModal = ({ onClick }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Handles button click
  const handleButtonClick = async () => {
    // Call the parent's validation/save function
    // If it returns false, don't open the modal
    // If it returns true or nothing, open the modal
    const shouldOpenModal = await (onClick?.() ?? true);
    if (shouldOpenModal === false) return; // Parent says "do not show modal"
    setIsModalOpen(true);
    setTimeout(() => setIsModalOpen(false), 2000);
  };

  return (
    <div>
      <div className="flex justify-end md:mt-3 mt-4">
        <button
          onClick={handleButtonClick}
          className="flex items-center md:gap-2 gap-2 text-black md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition"
        >
          Save
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
            alt="Save Icon"
            className="md:w-11 md:h-11 h-3 w-3"
          />
        </button>
      </div>

      {/* Modal for "Records Saved" message */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Save Success"
        className="flex justify-center items-center fixed inset-0"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      >
        <div className="bg-white p-6 rounded-md text-center md:w-[500px] md:h-[300px] flex items-center justify-center">
          <span className="text-[40px] mr-2">✅</span>
          <h2 className="md:text-[48px] text-[20px] font-bold">Records Saved!</h2>
        </div>
      </Modal>
    </div>
  );
};

export default SaveButtonWithModal;